// Set current year in footer
document.getElementById("current-year").textContent = new Date().getFullYear();

// Tabs functionality
const tabTriggers = document.querySelectorAll(".tab-trigger");
const tabContents = document.querySelectorAll(".tab-content");

tabTriggers.forEach((trigger) => {
  trigger.addEventListener("click", () => {
    // Remove active class from all triggers and contents
    tabTriggers.forEach((t) => t.classList.remove("active"));
    tabContents.forEach((c) => c.classList.remove("active"));

    // Add active class to clicked trigger and corresponding content
    trigger.classList.add("active");
    const tabId = trigger.getAttribute("data-tab");
    document.getElementById(`${tabId}-tab`).classList.add("active");
  });
});

// Smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const targetId = this.getAttribute("href");
    if (targetId === "#") return;

    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 80, // Adjust for header height
        behavior: "smooth",
      });
    }
  });
});

// Scroll reveal
document.addEventListener("DOMContentLoaded", () => {
  ScrollReveal({ distance: "60px", duration: 1000, delay: 200 });

  ScrollReveal().reveal(".reveal-section-left", {
    origin: "left",
  });

  ScrollReveal().reveal(".reveal-section-right", {
    origin: "right",
  });

  ScrollReveal().reveal(".reveal-section-top", {
    origin: "top",
  });

  ScrollReveal().reveal(".reveal-section-bottom", {
    origin: "bottom",
  });
});
